import { useHandler } from "@redotech/react-util/hook";
import { TrackedVariant } from "@redotech/redo-model/extended-warranty";
import { useEffect, useMemo, useState } from "react";
import { shopifyProductHandle } from "../../shopify";
import { getVariantIdFromUrl } from "../../utils";

function getVariantDetailsFromWindow(
  variantId: string | null | undefined,
): TrackedVariant | undefined {
  // It's possible the productId is not related to selected variant.
  const productId: string = (globalThis as any).ShopifyAnalytics?.meta?.product
    ?.id;
  const handle: string = shopifyProductHandle(location.href);
  const variants: { id: string; product_id: string; price: number }[] =
    (globalThis as any).ShopifyAnalytics?.meta?.product?.variants || [];
  const variant = variants.find((v: any) => String(v.id) === variantId);
  if (!variant) {
    if (variants[0]) {
      return {
        variantId: variants[0].id,
        productId,
        price: variants[0].price,
        handle,
      };
    }
    return undefined;
  }
  return { variantId: variant.id, productId, price: variant.price, handle };
}

export function useWindowVariantDetails(): {
  variantDetails: TrackedVariant | undefined;
} {
  // Retrieving relevant information for the provider
  const [windowVariantId, setWindowVariantId] = useState<string | undefined>(
    undefined,
  );

  const resetVariant = useHandler(() => {
    setWindowVariantId(getVariantIdFromUrl(location.href) ?? undefined);
  });

  const overrideWindowHistory = useHandler(() => {
    const originalReplaceState = history.replaceState;
    history.replaceState = function (
      ...args: Parameters<typeof history.replaceState>
    ) {
      originalReplaceState.apply(history, args);
      resetVariant();
    };
  });

  useEffect(() => {
    overrideWindowHistory();
    resetVariant();
  }, [resetVariant, overrideWindowHistory]);

  const variantDetails = useMemo(() => {
    return getVariantDetailsFromWindow(windowVariantId);
  }, [windowVariantId]);

  return { variantDetails };
}
